import { invokeApi } from "../utils";

export const registerCompanyApi = (postData) =>
  invokeApi({
    path: "/companies/register",
    method: "POST",
    postData,
  });

export const getAllCompaniesApi = () =>
  invokeApi({ path: "/companies", method: "GET" });

export const getCompanyByIdApi = (id) =>
  invokeApi({ path: `/companies/${id}`, method: "GET" });

export const updateCompanyApi = (id, postData) =>
  invokeApi({ path: `/companies/${id}`, method: "POST", postData });

export const getModulesApi = () =>
  invokeApi({ path: "/modules", method: "GET" });

export const getModuleFeaturesApi = (moduleId) =>
  invokeApi({ path: `/modules/${moduleId}/features`, method: "GET" });

export const deleteCompanyApi = (id) =>
  invokeApi({ path: `/companies/${id}`, method: "DELETE" });

export const getDashboardStatsApi = (companyId) =>
  invokeApi({ path: `/companies/${companyId}/dashboardStats`, method: "GET" });
